import { render, staticRenderFns } from "./ResultsByMatchCard.vue?vue&type=template&id=5aa2aa97&"
import script from "./ResultsByMatchCard.vue?vue&type=script&lang=js&"
export * from "./ResultsByMatchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports